module.exports = __webpack_public_path__ + "static/media/separate_building_entry.6f501c07.svg";